import React from 'react'
import styled from 'styled-components'
import { Header } from 'Components'
import { MEDIA_WIDTHS } from 'Themes'
import { useLocation, useParams } from 'react-router-dom'
import { Layout } from 'antd'
import SideBar from 'Components/siderBar'

const { Content } = Layout

const Wrapper = styled.div`
  .svg.ant-menu-item-icon {
    color: black;
  }
  .sider-class {
    padding-top: 63px;
    height: 100vh;
    position: sticky;
    overflow: auto;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 999;
  }
  .collapse {
    width: 100%;
    max-height: 40px;
    line-height: 40px;
    text-align: left;
    box-shadow: inset 0 1px 0 #F0F0F0;
    padding: 0 16px;

    border: none;
    cursor: pointer;

    position: sticky;
    bottom: 0;
    background-color: white;
  }
  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  span.ant-breadcrumb-link {
    margin-bottom: 20px;
    font-weight: 700;
    font-size: 30px;
    line-height: 24px;
    color: #000000;
  }
  nav.ant-breadcrumb {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  section.ant-layout {
    background-color: #FAFAFA;
  }
`

export const SettingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 412px;
  width: 100%;
  height: fit-content;
  align-items: center;
  margin: 40px auto 0;
  .title-screen {
    line-height: 20px;
    color: ${({ theme }) => theme.black};
    font-weight: 700;
    margin-bottom: 9px;
    font-size: 20px;
  }

  .content-body {
    width: 100%;
    padding: 24px 36px 22px 36px;
    background: ${({ theme }) => theme.white};
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
  }

  .nav {
    width: 100%;

    display: flex;
    flex-direction: row;
    justify-content: ${({ theme }) => theme.justify};
    gap: 32px;
    align-items: center;
    margin-bottom: 24px;

    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    a {
      color: #000000;
    }
    .active {
      padding-bottom: 6px;
      border-bottom: 3px solid #2E77D0;
    }
  }

  @media only screen and (max-width: ${MEDIA_WIDTHS.upToExtraSmall}px) {
    max-width: 400px;
  }
`

const AccountInfoScreen = ({ children }) => {
  const location = useLocation()
  const { idUser } = useParams()
  const dataPlan = [{
    title: 'ACCOUNT INFO',
    to: `/account-info/${idUser}`,
    isShow: true
  }
  // {
  //   title: '２FA SETTING',
  //   to: '/2fa',
  //   isShow: true
  // },
  // {
  //   title: 'CHANGE PLAN',
  //   to: '/change-plan',
  //   isShow: true
  // }
  ]

  return (
    <Wrapper>
      <Layout>
        <Header />
        <Layout>
          <SideBar />
          <Layout
            style={{
              padding: '17px 24px 24px',
              overflow: 'initial',
              minHeight: 'auto',
              marginTop: '63px'
            }}
          >
            <Content
              className="content"
            >
              <SettingWrapper theme={{ white: '#FFFFFF', black: '#000000', justify: 'center' }}>
                <div className="nav">
                  {dataPlan.map((item) => (
                    item.isShow && <div key={item.title} to={item.to}><span className={location.pathname === item.to ? 'active' : ''}>{item.title}</span></div>
                  ))}
                </div>
                <div className="content-body">
                  {children}
                </div>
              </SettingWrapper>
            </Content>
          </Layout>
        </Layout>
      </Layout>
    </Wrapper>
  )
}

export default AccountInfoScreen
